import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import { strSortFn, adminPropertyShape } from '../helperFunctions';
import AdminPropertyTable from './AdminPropertyTable';

import List from '../List';

const adminPropertiesViewFilters = [
  {
    id: 'ALL_PROPERTIES_VIEW',
    label: 'All Properties',
    filterFn: () => true
  },
  // status: Draft, Pending, Approved, Rejected, Archived, Published
  {
    id: 'DRAFT_PROPERTIES',
    label: 'Status: Draft',
    filterFn: (item) => item.status === 'Draft'
  },
  {
    id: 'APPROVED_PROPERTIES',
    label: 'Status: Approved',
    filterFn: (item) => item.status === 'Approved'
  },
  {
    id: 'PUBLISHED_PROPERTIES',
    label: 'Status: Published',
    filterFn: (item) => item.status === 'Published'
  },
  {
    id: 'ARCHIVED_PROPERTIES',
    label: 'Status: Archived',
    filterFn: (item) => item.status === 'Archived'
  }
];

const adminPropertiesSortFilters = [
  {
    id: 'PROPERTY_NAME_SORT',
    label: 'Property Name (asc)',
    sortFn: (a, b) => strSortFn(a, b, 'name')
  },
  {
    id: 'PROPERTY_NAME_SORT_DESC',
    label: 'Property Name (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'name', 'desc')
  },
  {
    id: 'PROPERTY_UPDATE_SORT',
    label: 'Recently Updated (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'lastUpdated')
  },
  {
    id: 'PROPERTY_UPDATE_SORT_DESC',
    label: 'Recently Updated',
    sortFn: (a, b) => strSortFn(a, b, 'lastUpdated', 'desc')
  },
  {
    id: 'PROPERTY_LOCATION_SORT',
    label: 'City (asc)',
    sortFn: (a, b) => strSortFn(a, b, 'city')
  },
  {
    id: 'PROPERTY_LOCATION_SORT_DESC',
    label: 'City (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'city', 'desc')
  }
];

function AdminPropertyList(props) {
  const { allProperties, loading, error, orgId, openTaxes, openEditor } = props;
  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <List
          data={allProperties}
          loading={loading}
          error={error}
          viewFilters={adminPropertiesViewFilters}
          sortFilters={adminPropertiesSortFilters}
          screenClass={screenClass}
          tableComponent={AdminPropertyTable}
          helpText="Search by property name, location or status"
          noDataObj={{
            message: 'There are no properties for that search, or no properties have been created',
            title: 'No Properties'
          }}
          searchBy={['name', 'city', 'region', 'status']}
          listComponentProps={{ defaultView: 'tableView', initialSortFilterId: 'PROPERTY_UPDATE_SORT_DESC' }}
          otherComponentProps={{ orgId, openTaxes, openEditor }}
        />
      )}
    />
  );
}

AdminPropertyList.propTypes = {
  allProperties: PropTypes.arrayOf(adminPropertyShape).isRequired,
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  orgId: PropTypes.string,
  openTaxes: PropTypes.func.isRequired,
  openEditor: PropTypes.func.isRequired
};

AdminPropertyList.defaultProps = {
  loading: true,
  error: null,
  orgId: ''
};

export default AdminPropertyList;
